export default "__VITE_ASSET__DlfHQHl$__"